import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import { PatientAPIConnectors } from '../../api';
import Link from '../../components/shared/Link';

class CreateAssessmentContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      depth: '',
      width: '',
      height: '',
      info: {},
      painIndex: 0,
      woundId: this.props.woundId,
      medicalRecordId: this.props.medicalRecordId,
    };

    this.create = this.create.bind(this);
    this.handleDepthChange = this.handleDepthChange.bind(this);
    this.handleHeightChange = this.handleHeightChange.bind(this);
    this.handleWidthChange = this.handleWidthChange.bind(this);
  }

  create(e) {
    e.preventDefault();

    const { actions, router } = this.props;
    const assessment = Object.assign({}, this.state);

    PatientAPIConnectors.createAssessment(assessment)
      .then(() => {
        actions.createSuccessAlert(i18n.t('createSucceedMsg_detail'));
        setTimeout(() => {
          router.navigate(`/medical-records/${this.props.medicalRecordId}`, {
            trigger: true,
          });
        }, 1000);
      })
      .catch((err) => {
        actions.createAlert(err);
      });
  }

  handleDepthChange(e) {
    this.setState({ depth: Number(e.target.value) });
  }

  handleWidthChange(e) {
    this.setState({ width: Number(e.target.value) });
  }

  handleHeightChange(e) {
    this.setState({ height: Number(e.target.value) });
  }

  createValidate = () => (
    this.state.width !== ''
    && this.state.depth !== ''
    && this.state.height !== ''
  );

  render() {
    return (
      <div className="well center col-lg-8 col-lg-offset-2">
        <form className="form-horizontal">
          <fieldset>
            <legend>
              {i18n.t('assessmentInfo')}
            </legend>
            <div className="form-group">
              <label htmlFor="inputID" className="col-lg-2 control-label">
                {i18n.t('depth_cm')}
              </label>
              <div className="col-lg-10">
                <input
                  type="text"
                  className="form-control"
                  id="inputID"
                  placeholder={i18n.t('depth_cm')}
                  required
                  onChange={this.handleDepthChange}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="inputFirstName" className="col-lg-2 control-label">
                {i18n.t('width_cm')}
              </label>
              <div className="col-lg-10">
                <input
                  type="text"
                  className="form-control"
                  id="inputFirstName"
                  placeholder={i18n.t('width_cm')}
                  required
                  onChange={this.handleWidthChange}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="inputLastName" className="col-lg-2 control-label">
                {i18n.t('length_cm')}
              </label>
              <div className="col-lg-10">
                <input
                  type="text"
                  className="form-control"
                  id="inputLastName"
                  placeholder={i18n.t('length_cm')}
                  required
                  onChange={this.handleHeightChange}
                />
              </div>
            </div>
          </fieldset>

          <div className="row">
            <div className="col-lg-5 center-block" style={{ float: 'none' }}>
              <button
                className="btn btn-success"
                onClick={this.create}
                disabled={!this.createValidate()}
              >
                {i18n.t('create')}
              </button>
              <Link
                href={`/medical-records/${this.props.medicalRecordId}`}
                router={this.props.router}
              >
                <button className="btn btn-default">
                  {i18n.t('cancel')}
                </button>
              </Link>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

CreateAssessmentContainer.propTypes = {
  medicalRecordId: PropTypes.number.isRequired,
  woundId: PropTypes.number.isRequired,
};

export default connectActionsAndReducers(CreateAssessmentContainer);



// WEBPACK FOOTER //
// ./src/containers/patient/CreateAssessmentContainer.js